exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__row.today td {\n  border: 1px solid red;\n}\n.time-asset.last-edit {\n  filter: contrast(1.1);\n  background-color: white;\n  box-shadow: 0px 0px 14px white;\n}\n.el-table__row.tomorrow td {\n  border: 1px dotted #dd4e4e;\n}\n.timeline-dark {\n  background-color: #033740;\n}\n.vis-label.collapsed {\n  color: #e3cbaa !important;\n}\n.vis-label.expanded {\n  color: rgb(215, 235, 215);\n}\n", ""]);

// exports
